import { requestHandler } from 'lib/api';

export const getUfValue = async (dispatch: any, query?: string) => {
  const url = query ? `internal/cmf/uf?${query}` : 'internal/cmf/uf';
  const response = await requestHandler({
    method: 'get',
    url,
    dispatch,
  });
  if (response) return response.data;
};

export const getDollarValue = async (dispatch: any, query?: string) => {
  const url = query ? `internal/cmf/dollar?${query}` : 'internal/cmf/dollar';
  const response = await requestHandler({
    method: 'get',
    url,
    dispatch,
  });

  if (response) return response.data;
};
